import { render, staticRenderFns } from "./ydr_korPostage.vue?vue&type=template&id=68bac62d&scoped=true&"
import script from "./ydr_korPostage.vue?vue&type=script&lang=js&"
export * from "./ydr_korPostage.vue?vue&type=script&lang=js&"
import style0 from "./ydr_korPostage.vue?vue&type=style&index=0&id=68bac62d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bac62d",
  null
  
)

export default component.exports